export default __webpack_public_path__ + "static/media/striding-feather-jr.2d5d1c29.jpg";